import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import ReviewsLayer from "../components/ReviewsLayer";

const ReviewsPage = () => {
  return (
    <>
      <Breadcrumb title="Reviews" />
      <ReviewsLayer />
    </>
  );
};

export default ReviewsPage;